import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import '../InfluencerSignUp.css';
import ChipInput from 'material-ui-chip-input';
import { withStyles } from '@material-ui/core/styles';
import { industrySelections } from '../../../../constants';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import HpTooltip from '../../../../components/shared/components/hpTooltip';

const styles = theme => ({
  interestsInput: {
    width: '70%',
    marginBottom: '75px',
    marginTop: '20px'
  },
  descriptionInput: {
    width: '90%',
    textAlign: 'center',
    marginBottom: '20px'
  },
  chips: {
    marginTop: '10px',
    width: '90%'
  },
  profileShowUpText: {
    marginLeft: '5px'
  },
  selectMenu: {
    '& .MuiPopover-paper': {
      maxHeight: 250
    }
  },
  select: {
    width: '250px',
    marginTop: '0px',
    background: 'white',
    '& > *': {
      maxWidth: 500,
      width: '100%',
      margin: '0 auto'
    }
  },
  buttons: {
    marginTop: '50px',
    display: 'flex',
    justifyContent: 'center'
  },
  nextButton: {
    marginTop: theme.spacing.unit * 3,
    color: '#ffffff',
    paddingLeft: 50,
    paddingRight: 50
  },
  backButton: {
    marginTop: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit,
    color: '#000000',
    paddingLeft: 50,
    paddingRight: 50
  }
});

class InfluencerContent extends React.Component {
  constructor() {
    super();

    this.initialState = {
      submitAttempted: false,
      termsChecked: false,
      industryError: '',
      descriptionError: '',
      audienceError: '',
      tagsError: ''
    };

    this.state = {
      ...this.initialState
    };
  }

  handleFinish() {
    this.setState({
      submitAttempted: true
    });
    if (!this.props.industry) {
      this.setState({
        industryError: 'industry is required'
      });
    } else {
      this.setState({
        industryError: ''
      });
    }

    if (!this.props.description) {
      this.setState({
        descriptionError: 'description is required'
      });
    } else {
      this.setState({
        descriptionError: ''
      });
    }

    if (!this.props.audience) {
      this.setState({
        audienceError: 'audience is required'
      });
    } else {
      this.setState({
        audienceError: ''
      });
    }

    if (!this.props.interests || !this.props.interests.length) {
      this.setState({
        tagsError: 'please add at least one content tag'
      });
    } else {
      this.setState({
        tagsError: ''
      });
    }

    if (
      this.props.industry &&
      this.props.description &&
      this.props.audience &&
      this.props.interests &&
      this.props.interests.length
    ) {
      this.props.handleFinishClick();
    }
  }

  handleTermsCheck(){
    this.setState({termsChecked: !this.state.termsChecked});
  }

  render() {
    const {
      classes,
      changeHandler,
      interestChange,
      interests,
      industry,
      description,
      audience
    } = this.props;

    return (
      <React.Fragment>
        <Grid
          container
          spacing={4}
          alignItems="center"
          justify="center"
          direction="column"
        >
          <Grid item xs={12} sm={12} className={classes.descriptionInput}>
            <div>
              <Typography
                variant="h6"
                gutterBottom
                color="textSecondary"
                className="info-helper-text"
              >
                Industry
              </Typography>
              <HpTooltip
                styling={{
                  marginLeft: '5px',
                  marginBottom: '3px'
                }}
                message={
                  'Select the industry that most closely aligns with your content.'
                }
              />
            </div>
            <TextField
              id="industry"
              name="industry"
              select
              fullWidth
              onChange={changeHandler}
              className={classes.select}
              SelectProps={{
                MenuProps: {
                  className: classes.industryMenu
                }
              }}
              margin="normal"
              variant="outlined"
              value={industry}
              error={
                this.state.submitAttempted && this.state.industryError
                  ? true
                  : false
              }
              helperText={
                this.state.submitAttempted ? this.state.industryError : ''
              }
            >
              {industrySelections.map((item, i) => (
                <MenuItem key={i} value={item}>
                  {item}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={12} className={classes.descriptionInput}>
            <div>
              <Typography
                display="inline"
                variant="h6"
                gutterBottom
                align="center"
                className="info-helper-text"
                color="textSecondary"
              >
                Content Description
              </Typography>
              <HpTooltip
                styling={{
                  marginLeft: '5px',
                  marginBottom: '3px'
                }}
                message={
                  'Please describe your content. Companies will see this on your profile.'
                }
              />
            </div>
            <Typography
              display="inline"
              variant="body1"
              gutterBottom
              align="center"
              className="info-helper-text"
              color="textSecondary"
              className={classes.profileShowUpText}
            >
              (this will show up on your profile)
            </Typography>
            <TextField
              id="description"
              name="description"
              margin="dense"
              variant="outlined"
              className="info-input"
              multiline={true}
              onChange={changeHandler}
              error={
                this.state.submitAttempted && this.state.descriptionError
                  ? true
                  : false
              }
              helperText={
                this.state.submitAttempted ? this.state.descriptionError : ''
              }
            />
            <Typography
              variant="subtitle2"
              gutterBottom
              align="center"
              className="info-helper-text"
              color="textSecondary"
            >
              Example:
              <br />
              Gluten free Chinese cooking recipes
              <br />
              Atlanta based supermodel pictures
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} className={classes.descriptionInput}>
            <div>
              <Typography
                display="inline"
                variant="h6"
                gutterBottom
                align="center"
                className="info-helper-text"
                color="textSecondary"
              >
                Content Audience
              </Typography>
              <HpTooltip
                styling={{
                  marginLeft: '5px',
                  marginBottom: '3px'
                }}
                message={'Please describe your content audience.'}
              />
            </div>
            <TextField
              id="audience"
              display="inline"
              name="audience"
              margin="dense"
              variant="outlined"
              className="info-input"
              multiline={true}
              onChange={changeHandler}
              error={
                this.state.submitAttempted && this.state.audienceError
                  ? true
                  : false
              }
              helperText={
                this.state.submitAttempted ? this.state.audienceError : ''
              }
            />
            <Typography
              variant="subtitle2"
              gutterBottom
              align="center"
              className="info-helper-text"
              color="textSecondary"
            >
              Example:
              <br />
              18-25 year old who plays fantasy MMO's
              <br />
              Former baseball coaches who still love the game
            </Typography>
          </Grid>
          <Grid item sm={12} className={classes.descriptionInput}>
            <div>
              <Typography
                variant="h6"
                display="inline"
                gutterBottom
                align="center"
                className="info-helper-text"
                color="textSecondary"
              >
                Content Tags
              </Typography>
              <HpTooltip
                styling={{
                  marginLeft: '5px',
                  marginBottom: '3px'
                }}
                message={
                  'Enter a few tags that describe your content (Fortnight, DOTA, Gadgets, etc.).'
                }
              />
            </div>
            <Typography
              display="inline"
              variant="body1"
              gutterBottom
              align="center"
              className="info-helper-text"
              color="textSecondary"
              className={classes.profileShowUpText}
            >
              (this helps companies find you)
            </Typography>
            <ChipInput
              value={interests}
              className={classes.chips}
              onChange={interestChange}
              color="primary"
              placeholder="type and press enter to add"
              alwaysShowPlaceholder={false}
              error={
                this.state.submitAttempted && this.state.tagsError
                  ? true
                  : false
              }
              helperText={
                this.state.submitAttempted ? this.state.tagsError : ''
              }
            />
          </Grid>
          <Grid item sm={12} className={classes.descriptionInput}>
            {/*<input type="checkbox" id="youtubeConsent" name="youtubeConsent" value="youtubeConsent"/>*/}
            {/*  <label htmlFor="youtubeConsent"> Consent to use YouTube data</label>*/}
            {/*<br/>*/}
            <input type="checkbox" id="terms" name="terms" value="terms"
                   onChange={this.handleTermsCheck.bind(this)} defaultChecked={this.state.termsChecked}
            />
            <label htmlFor="terms">Agree to <a style={{ color: 'gray',textDecoration: "underline"}} onClick={() => {
              window.open("/terms-of-service", "_blank")
            }}>Terms of Service</a></label>
              <br/>
          </Grid>
          </Grid>
        <div className={classes.buttons}>
          <Button
            onClick={this.props.handleBackClick}
            className={classes.backButton}
          >
            Back
          </Button>
          <Button
              disabled={!this.state.termsChecked}
            variant="contained"
            color="primary"
            onClick={this.handleFinish.bind(this)}
            className={classes.nextButton}
          >
            Finish
          </Button>
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(InfluencerContent);



// WEBPACK FOOTER //
// ./src/components/sign-up/influencer/components/InfluencerContent.js